import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RoutingHelpersService } from '@polaris-customerweb/sharedcomponents.shared';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
export abstract class SvgLoader {
    abstract getSvg(url: string): Observable<string>;
}

@Injectable()
export class AngularSvgIconCustomLoader extends SvgLoader {
    constructor(
        private http: HttpClient,
        private routingHelpersService: RoutingHelpersService
    ) {
        super();
    }

    getSvg(url: string): Observable<string> {
        const isIconsUrl = url.includes('rdc-icons.polaris.com');

        return this.http
            .get(this.routingHelpersService.cleanResourceUrl(url), {
                responseType: 'text',
                withCredentials: !isIconsUrl,
            })
            .pipe(
                map((response) => {
                    if (isIconsUrl) {
                        const segments = url.split('/');
                        const name = segments[segments.length - 1].replace(
                            '.svg',
                            ''
                        );
                        // fix duplicate clipPath ids
                        return response
                            .replace(
                                /clipPath id="([\w-]*)"/g,
                                'clipPath id="$1-' + name + '"'
                            )
                            .replace(
                                /clip-path="url\(#([\w-]*)\)/g,
                                'clip-path="url(#$1-' + name + ')'
                            );
                    } else {
                        return response;
                    }
                })
            );
    }
}
